import { render } from "./wizard.vue?vue&type=template&id=04eb1005&scoped=true"
import script from "./wizard.vue?vue&type=script&lang=js"
export * from "./wizard.vue?vue&type=script&lang=js"

import "./wizard.vue?vue&type=style&index=0&id=04eb1005&lang=css"
import "./wizard.vue?vue&type=style&index=1&id=04eb1005&scoped=true&lang=css"

import exportComponent from "../../../../../procollege/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04eb1005"]])

export default __exports__